import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../../Services/_states';

export default function useAnalyticsSuperAdmin() {
  const userInfo = useRecoilValue(userInformationAtom);
  return Boolean(userInfo?.is_superuser);
}
